import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { Loader } from '@/components/Loader'
import { CommonError } from '@/shared/Auth/components/CommonError'
import { Row } from '@/shared/Auth/components/Row'
import { Title } from '@/shared/Auth/components/Title'
import { FC, FormEventHandler, useCallback } from 'react'
import styles from './PasswordResetRequest.module.scss'

interface PasswordResetRequest {
  className?: string
  isLoading?: boolean
  email: string
  errors?: {
    common?: string
    email?: string
  }
  changeEmail: (email: string, name?: string) => void
  resetPassword: () => void
}
export const PasswordResetRequest: FC<PasswordResetRequest> = ({
  className,
  isLoading = false,
  email,
  changeEmail,
  errors = {},
  resetPassword,
}) => {
  const send: FormEventHandler = useCallback(
    (event) => {
      event?.preventDefault()
      if (resetPassword) {
        resetPassword()
      }
    },
    [resetPassword]
  )
  return (
    <form className={className} onSubmit={send}>
      <Title title="Восстановление пароля" />
      <Row>
        <CommonError errors={errors} />
      </Row>
      <Row isAdditional>
        <Input
          className={styles.input}
          value={email}
          onChange={changeEmail}
          type="email"
          name="email"
          error={errors.email}
          placeholder="E-mail"
        />
      </Row>
      <Button className={styles.button} type="submit">
        {isLoading ? (
          <Loader className={styles.loader} onTop />
        ) : (
          'Отправить запрос'
        )}
      </Button>
    </form>
  )
}
